import React, { useEffect, useState } from 'react'
import Layout from '../layout/Layout'
import { AddAllocationFund, CheckAllocation, GetAllocatedStockList } from '../../api/myAccount'
import toast, { Toaster } from 'react-hot-toast';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { setInitialuserDetail } from '../../redux/auth/auth';
import { useDispatch } from 'react-redux';
import { useDocumentTitle } from '../../utils/Common';
import { useTheme } from '../../utils/theme';
export default function FundAllocation() {
    const { theme } = useTheme()
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [AllocationData, setAllocationData] = useState(null);
    const fetchData = async () => {
        try {
            const response = window.location.pathname == "/view-fund-allocation" ? await GetAllocatedStockList() : await CheckAllocation()
            setAllocationData(response.data);
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }
    useDocumentTitle("Fund Allocation")
    useEffect(() => {
        fetchData();
    }, [])

    const handleAddAllocationFund = async () => {
        let payload = {
            userId: localStorage.getItem("uid"),
            stocks: [],
        };

        AllocationData?.stocks?.map((item, idx) => {
            payload.stocks.push({
                invPortStockId: item.id,
                entryPrice: item.cmp,
                qty: item.qty
            })
        })

        try {
            const response = await AddAllocationFund(payload);
            if (response) {
                toast.success("Funds Allocated Successfully")
                dispatch(setInitialuserDetail());
                AllocationData?.invType === "equity" ? localStorage.setItem("selectedPortfolio", 1) : localStorage.setItem("selectedPortfolio", 2)
                navigate(AllocationData?.invType === "equity" ? "/portfolio" : "/etf");
            }
        } catch (error) {
            toast.error("Something Went Wrong")
        }
    }


    return (
        <Layout>
            <section id="create-portfolio" class="py-4">
                <div class="container">
                    <div class="row g-3 justify-content-between">
                        <div class="col-md-12">
                            <a href="/my-account" class="text-decoration-none text-body-emphasis fs-5"><i class="fa fa-arrow-left" aria-hidden="true"></i></a>
                        </div>
                        <div class="col-md-12">
                            <div class="d-flex gap-3 align-items-center">
                                <div class="">
                                    <h1 class="fs-4 fw-bold mb-0">Fund Allocation</h1>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-auto col-8">
                            <small class="text-muted d-block">Available</small>
                            <p class="mb-0 fs-5">₹ {AllocationData?.amt}</p>
                        </div>
                        <div class="col-md-auto col-4">
                            <small class="text-muted d-block">Financial Product</small>
                            <p class="mb-0 text-capitalize">{AllocationData?.invType}</p>
                        </div>
                        <div class="col-md-auto col-8">
                            <small class="text-muted d-block">Fund Added</small>
                            <p class="mb-0">{moment(AllocationData?.fundAddedAt).format("DD MMM, YYYY")}</p>
                        </div>
                        <div class="col-md-auto col-4">
                            <small class="text-muted d-block">No. Of Stocks</small>
                            <p class="mb-0">{AllocationData?.stocks?.length} Stocks</p>
                        </div>

                        <div class="col-md-12">
                            <div class="table-responsive border rounded-3">
                                {/* <table class="table table-hover table-striped"> */}
                                <table
                                    className="table table-hover table-striped m-0"
                                    style={
                                        theme === "dark"
                                            ? {
                                                backgroundColor: "#0A0A0B",
                                                color: "#FFFFFF",
                                            }
                                            : {}
                                    }
                                >
                                    <thead>
                                        <tr>
                                            <th style={{ "minWidth": "140px" }}>Company</th>
                                            <th style={{ "minWidth": "140px" }} class="text-end">CMP</th>
                                            <th style={{ "minWidth": "140px" }} class="text-end">Qty.</th>
                                            <th style={{ "minWidth": "140px" }} class="text-end">Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {AllocationData?.stocks?.map((item, idx) => (
                                            <tr>
                                                <td>{item.scrip}</td>
                                                <td class="text-end">{window.location.pathname == "/view-fund-allocation" ? item.entryPrice : item.cmp}</td>
                                                <td class="text-end">{item.qty}</td>
                                                <td class="text-end">{window.location.pathname == "/view-fund-allocation" ? item.invested : item.recInvestAmt}</td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td></td>
                                            <td class="text-end"></td>
                                            <td class="text-end fw-bold">Sum</td>
                                            <td class="text-end fw-bold">{AllocationData?.totalInvestAmt.toLocaleString("en-IN", { maximumFractionDigits: 2 })}</td>
                                        </tr>

                                        {/* <tr>
                                            <td>TCS</td>
                                            <td class="text-end">1400</td>
                                            <td class="text-end">250</td>
                                            <td class="text-end">1,00,000</td>
                                        </tr>
                                        <tr>
                                            <td>HDFC</td>
                                            <td class="text-end">980</td>
                                            <td class="text-end">350</td>
                                            <td class="text-end">1,00,000</td>
                                        </tr> */}
                                    </tbody>

                                </table>
                            </div>
                            <div className={window.location.pathname == "/view-fund-allocation" ? "d-none" : "text-center text-md-end mt-3"}>
                                <button class="btn btn-outline-dark me-3"
                                    onClick={() => {
                                        navigate("/my-account");
                                    }}
                                >Cancel</button>
                                <button class="btn btn-dark"
                                    onClick={() => {
                                        handleAddAllocationFund();
                                    }}
                                >Confirm</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Toaster />
        </Layout>
    )
}
